import { send } from "../api.js";

/**
 * Mark a credit-funded lesson unpaid through WMF-SIte's single authoritative
 * operation. The browser deliberately does not choose a lesson block or mutate
 * the credit ledger itself: FastAPI resolves the exact unrestored USE, ensures
 * the appointment has a real pending payment, and only then restores the
 * entitlement (including Amelia coupon allowance where applicable).
 */
export async function markCreditedLessonUnpaid(
  appointmentId: number,
  studentId: string,
  idempotencyKey: string,
): Promise<void> {
  await send<unknown>(
    "PATCH",
    `/staff-api/api/v1/appointments/${appointmentId}/credit/pending`,
    { portal_student_id: studentId },
    { "Idempotency-Key": idempotencyKey },
  );
}
